export const OPTIMIZELY_CONSTANTS = {
  aboutHeroCompleted: 'About Hero Completed',
  aboutBusinessCompleted: 'About Business Completed',
  skipToCheckoutClicked: 'Skip to Checkout Clicked',
  businessStageCompleted: 'Business Stage Completed',
  businessSizeCompleted: 'Business Size Completed',
  businessGoalsCompleted: 'Business Goals Completed',
  startFreeTrialClicked: 'Start Free Trial Clicked',
  continueToCheckoutClicked: 'OpenAI Error - Continue to Checkout Clicked',
  tryAgainClicked: 'OpenAI Error - Try Again Clicked',
  viewPreviewClicked: 'OpenAI Error - View Preview Clicked',
  continueWithGoogleClicked: 'Continue with Google Button Clicked',
  planToSellCompleted: 'Plan to Sell Completed',
};

export const RUDDERSTACK_CONSTANTS = {
  buttonClicked: 'AI Lead Gen next button clicked',
  slideViewed: 'AI Lead Gen Slide Viewed',
  businessTopicSlideName: 'Business topic',
  businessPreviewSlideName: 'Business preview',
  productPlansSlideName: 'Product plans',
};

export function rudderstackTrackEvent(
  slideName: string,
  eventType: string,
  optimizelyId: number
) {
  window.LandersTracking?.trackEvent(eventType, {
    slideName: slideName,
    optimizelyId: optimizelyId,
  });
}

export const BUSINESS_STAGE_OPTIONS = [
  {
    caption: 'Trying to get your business off the ground',
    label: 'Pre-launch / planning',
    value: 'business-pre-launch',
  },
  {
    caption: 'In the beginning stages of your business',
    label: 'Launch / start-up',
    value: 'business-launch',
  },
  {
    caption: 'In the process of growing your business',
    label: 'Growth',
    value: 'business-growth',
  },
  {
    caption: 'In a steady state of business',
    label: 'Mature / established',
    value: 'business-mature',
  },
];

export const INDUSTRY_SELECT_OPTIONS = [
  {
    value: 'placeholder',
    label: 'Choose an industry...',
    disabled: true,
  },
  {
    label: 'Health & Fitness',
    value: 'health_fitness',
  },
  {
    label: 'Business & Finance',
    value: 'business_finance',
  },
  {
    label: 'Fashion & Beauty',
    value: 'fashion_beauty',
  },
  {
    label: 'Lifestyle & Hobbies',
    value: 'lifestyle_hobbies',
  },
  {
    label: 'Personal Development',
    value: 'personal_development',
  },
  {
    label: 'Family & Parenting',
    value: 'family_parenting',
  },
  {
    label: 'Design',
    value: 'design',
  },
  {
    label: 'Academics & Teacher Training',
    value: 'academics_teacher_training',
  },
  {
    label: 'Software & Technology',
    value: 'software_technology',
  },
  {
    label: 'Marketing',
    value: 'marketing',
  },
  {
    label: 'Music & Instruments',
    value: 'music_instruments',
  },
  {
    label: 'Photo & Video',
    value: 'photo_video',
  },
  {
    label: 'Organization & Productivity',
    value: 'organization_productivity',
  },
  {
    label: 'Travel & Languages',
    value: 'travel_languages',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const COURSE_ID = 'course';
export const COACHING_PROGRAM_ID = 'coaching_program';
export const COMMUNITY_ID = 'community';
export const PODCAST_ID = 'podcast';
export const CHECKOUT_ID = 'checkout';
export const SALES_EMAIL_ID = 'sales_email';
export const LANDING_PAGE_ID = 'landing_page';

export const PRODUCT_PLANS_OPTIONS = [
  { label: 'Launch a course', value: COURSE_ID },
  { label: 'Launch a coaching program', value: COACHING_PROGRAM_ID },
  { label: 'Launch a community', value: COMMUNITY_ID },
  { label: 'Start a podcast', value: PODCAST_ID },
];

export const COPY_MAGIC_PROMPTS = {
  coachingFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_COACHING',
  coachingFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_COACHING',
  communityFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_COMMUNITY',
  communityFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_COMMUNITY',
  courseFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_COURSE',
  courseFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_COURSE',
  podcastFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_PODCAST',
  podcastFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_PODCAST',
  landingPageFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_LANDING_PAGE',
  landingPageFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_LANDING_PAGE',
  salesEmailFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_SALES_EMAIL',
  salesEmailFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_SALES_EMAIL',
  checkoutPageFromTopic: 'GROWTH_API_CONTENT_ASSISTANT_CHECKOUT',
  checkoutPageFromYoutube: 'GROWTH_API_YOUTUBE_ASSISTANT_CHECKOUT',
};

export const PRODUCT_PROMPTS = {
  [COACHING_PROGRAM_ID]: {
    youtube: COPY_MAGIC_PROMPTS.coachingFromYoutube,
    topic: COPY_MAGIC_PROMPTS.coachingFromTopic,
  },
  [COMMUNITY_ID]: {
    youtube: COPY_MAGIC_PROMPTS.communityFromYoutube,
    topic: COPY_MAGIC_PROMPTS.communityFromTopic,
  },
  [COURSE_ID]: {
    youtube: COPY_MAGIC_PROMPTS.courseFromYoutube,
    topic: COPY_MAGIC_PROMPTS.courseFromTopic,
  },
  [PODCAST_ID]: {
    youtube: COPY_MAGIC_PROMPTS.podcastFromYoutube,
    topic: COPY_MAGIC_PROMPTS.podcastFromTopic,
  },
};

export const BUSINESS_GOALS = [
  'Validate my business idea',
  'Launch a course',
  'Start a podcast',
  'Launch a community',
  'Launch a coaching program',
  'I was hired to setup Kajabi',
  'Migrate my existing business onto Kajabi',
];
export const AUDIENCE_SIZE_OPTIONS = {
  option_1: '0 - 999',
  option_2: '1,000 - 10,000',
  option_3: '10,000 - 50,000',
  option_4: '50,000 - 100,000',
  option_5: '100,000 - 999,999',
  option_6: '1,000,000 or more',
};

export const AUTOMATION_TOOLTIP_COPY = `Automations send a series of emails to
nurture your leads to drive purchases.`;

export const FORM_TOOLTIP_COPY = `Forms collect information for visitors to
build your email list for marketing.`;

export const SALES_EMAIL_TOOLTIP_COPY = `Showcase value, offer incentives, and
create a sense of urgency to increase conversion.`;

export const COACHING_PROGRAM_SESSIONS_ARRAY = [
  { sessionNumber: 'Session 3', sessionDate: 'In 2 weeks' },
  { sessionNumber: 'Session 4', sessionDate: 'In 4 weeks' },
  { sessionNumber: 'Session 5', sessionDate: 'In 6 weeks' },
];

export const COMMUNITY_LINKS = [
  {
    title: 'General',
    links: ['Q&A', 'Feedback', 'New Ideas'],
  },
  {
    title: 'Beginners',
    links: ['Basics', 'Intermediate', 'Advanced'],
  },
];

export const BUSINESS_TOPIC_MIN_CHARS = 3;
export const BUSINESS_TOPIC_MAX_CHARS = 1000;
export const ERROR_BUSINESS_TOPIC = 'Use between three and 1000 characters.';
export const ERROR_YOUTUBE_URL = 'Please enter a valid youtube URL';


export const CHANNEL_REGEX = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/channel\/[a-zA-Z0-9_-]+/
export const HANDLE_REGEX = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/@([a-zA-Z0-9_-]+)/
export const PLAYLIST_REGEX = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/playlist\?list=[^&]+/
export const CUSTOM_URL_REGEX = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/c\/[a-zA-Z0-9_-]+/
export const USERNAME_REGEX = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/user\/[a-zA-Z0-9_-]+/
